import { accessRole } from "../../../../helpers/access_role";

import React, { Fragment, Component, createRef } from "react";
import classnames from "classnames";
import { Link } from "react-router-dom";

import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Modal,
  Badge,
} from "reactstrap";
import CustomSelect from "../../GlobalComponents/CustomSelect";
import TableActiveComponent from "./Components/TableActiveComponent";
import { FileInput, generateFormData } from "../../../../helpers/ui/FileInput";
import { ConfirmAlert } from "../../../../helpers/ui/alert";
import { AvForm, AvField } from "availity-reactstrap-validation";
// import CreateBloc from "../Create/Blocs/CreateBloc";
import apiResponse from "../../../../services/apiResponse";
import DataTableBloc from "./Blocs/DataTableBloc";
import CreateBloc from "../Create/Blocs/CreateBloc";
import moment from "moment";
import Shimmer from "react-shimmer-effect";

var reformatWorkUnit = function (datas) {
  return datas.map(function (data) {
    var newObj = {};
    newObj["label"] = data.work_unit_name_full;
    newObj["value"] = data.work_unit_uuid;
    newObj["model"] = data;
    return newObj;
  });
};

var reformatAtasan = function (datas) {
  return datas.map(function (data) {
    var newObj = {};
    newObj["label"] = data.employee_name;
    newObj["value"] = data.employee_uuid;
    newObj["model"] = data;
    return newObj;
  });
};

class IndexView extends Component {
  historyMonth = "skp_history_month_tunsus"; //
  historyYear = "skp_history_year_tunsus"; //
  defaultOrder = "special_allowance_summary_id"; // orderBy
  userdata = JSON.parse(localStorage.getItem("userdata"));
  is_eselon =
    typeof this.userdata.echelon_code === "string" &&
    (this.userdata.echelon_code.startsWith("1") ||
      this.userdata.echelon_code.startsWith("2"))
      ? 1
      : 0;
  role = localStorage.getItem("currentRoleId");
  createBloc = new CreateBloc();
  dataTableBloc = new DataTableBloc();
  constructor(props) {
    super(props);
    this.state = {
      confirmInfo: "Apakah anda yakin akan menyimpan data ini?",
      failedInfo: "Data gagal disimpan",
      failedTitle: "Gagal!",
      dataForm: {},
      monthOptions: this.createMonthOptions(),
      yearOptions: this.createYearOption(new Date().getFullYear() - 30),
      hirarkiOptions: [],
      workUnitOptions: [],
      atasanOptions: [],
      month: localStorage.getItem(this.historyMonth)
        ? JSON.parse(localStorage.getItem(this.historyMonth))
        : moment().format("M"),
      year: localStorage.getItem(this.historyYear)
        ? JSON.parse(localStorage.getItem(this.historyYear))
        : moment().format("YYYY"),
      hirarkiSelected: "",
      roleId: localStorage.getItem("currentRoleId"),
      atasanSelected:
        this.role == 2 && this.is_eselon == 1
          ? this.userdata.employee_uuid
          : "",
      workUnitSelected: "",
      generate_verification_status: 1, //0
      showUpload: false,
      document: null,
      bulanpenilaian: 0,
      tahunpenilaian: 2024,
      skpgeneratedmsg: "",
      skpisverified: 0,
      bulanskp: 0,
      tahunskp: 0,
      currentMonth: 0,
      currentYear: 0,
      previewSearch: "",
      lockupload: 0,
      employee_full_name: null,
      upload_skp_create_date: null,
      loadingCekSKP: true,
    };
    this.activeRef = createRef();
  }
  createMonthOptions() {
    var months = [
      "Januari",
      "Februari",
      "Maret",
      "April",
      "Mei",
      "Juni",
      "Juli",
      "Agustus",
      "September",
      "Oktober",
      "November",
      "Desember",
    ];

    return months.map(function (month, i) {
      var newObj = {};
      newObj["label"] = month;
      newObj["value"] = ++i;

      return newObj;
    });
  }
  createYearOption(startYear = 2000) {
    var currentYear = new Date().getFullYear(),
      years = [];
    startYear = startYear || 1980;
    while (startYear <= currentYear) {
      var newObj = {};
      var year = startYear++;
      newObj["label"] = year;
      newObj["value"] = year;
      years.push(newObj);
    }
    return years;
  }

  getMonthName(monthNumber) {
    const monthNamesId = [
      "Januari",
      "Februari",
      "Maret",
      "April",
      "Mei",
      "Juni",
      "Juli",
      "Agustus",
      "September",
      "Oktober",
      "November",
      "Desember",
    ];

    // Ensure the monthNumber is within a valid range (1-12)
    if (monthNumber >= 1 && monthNumber <= 12) {
      return monthNamesId[monthNumber - 1]; // Adjusting for 0-based array indexing
    } else {
      return "Invalid Month";
    }
  }

  formatDateWithTime = (value) => {
    if (value != "-") {
      let date = new Date(value);
      const day = date.toLocaleString("id-ID", { day: "2-digit" });
      const month = date.toLocaleString("id-ID", { month: "short" });
      const year = date.toLocaleString("id-ID", { year: "numeric" });
      const time = date.toLocaleTimeString("id-ID");
      return (
        day +
        " " +
        month +
        " " +
        year +
        " " +
        time.substring(0, 5).replace(/\./g, ":")
      );
    } else {
      return value;
    }
  };

  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    this.setState({
      dataForm: {
        ...values,
        special_allowance_summary_month: this.state.month,
        special_allowance_summary_year: this.state.year,
      },
    }, () => {
       // Call preview API
       this.dataTableBloc.fetchPreviewUpload(this.convertToFormData(this.state.dataForm));
    });
  };
  submitData = async () => {
    await this.createBloc.fetchCreate(
      this.convertToFormData(this.state.dataForm)
    );
  };
  convertToFormData(data) {
    const formData = new FormData();

    for (const key in data) {
      const value = data[key];
      if (value !== null && value !== undefined) {
        if (Array.isArray(value)) {
          value.forEach((item, index) => {
            if (Array.isArray(item)) {
              item.forEach((itm, idx) => {
                if (itm !== null && itm !== undefined) {
                  formData.append(`${key}[${index}][]`, itm);
                }
              });
            } else {
              formData.append(`${key}[]`, item);
            }
          });
        } else {
          formData.append(key, value);
        }
      }
    }
    return formData;
  }

  handleperiodePenilaian(month, year) {
    var bulan = month; // Januari
    var tahun = year;
    // Mengurangi 2 dari bulan untuk mendapatkan bulan sebelumnya
    let bulanSebelumnya = bulan;
    let tahunSebelumnya = tahun;
    let bulanskp = bulan;
    let tahunskp = tahun;

    // Mendapatkan tanggal saat ini
    var currentDate = new Date();
    // Mendapatkan bulan (current month) dari tanggal saat ini (0-indexed, mulai dari 0 untuk Januari)
    var currentMonth = currentDate.getMonth() + 1; // Ditambah 1 karena bulan dimulai dari 0
    // Mendapatkan tahun (current year) dari tanggal saat ini
    var currentYear = currentDate.getFullYear();

    // Jika bulan adalah Januari, maka bulan sebelumnya adalah Desember dari tahun sebelumnya
    // if (bulanSebelumnya <= 0) {
    //     bulanSebelumnya += 12;
    //     tahunSebelumnya--;
    // }
    if (bulan == 1) {
      bulanSebelumnya = 11;
      tahunSebelumnya--;
    } else if (bulan == 2) {
      bulanSebelumnya = 12;
      tahunSebelumnya--;
    } else {
      bulanSebelumnya = bulan - 2;
      // tahunSebelumnya = tahunsebelumnya;
    }
    if (month == 12) {
      bulanskp = 1;
      tahunskp = year + 1;
    } else {
      tahunskp = month + 1;
      tahunskp = year;
    }
    this.setState({
      bulanpenilaian: bulanSebelumnya,
      tahunpenilaian: tahunSebelumnya,
      bulanskp: bulanskp,
      tahunskp: tahunskp,
      currentMonth: currentMonth,
      currentYear: currentYear,
    });
    // console.log(bulan);
    // console.log(tahun);
    // console.log(bulanSebelumnya);
    // console.log(tahunSebelumnya);

    this.dataTableBloc.fetchCheckVerifikasi({
      year: this.state.year,
      month: this.state.month,
    });
  }
  handleGenerateUlang() {
    this.dataTableBloc.fetchRegenerate({
      year: this.state.year,
      month: this.state.month,
    });
  }

  handleButtonVerifikasi() {
    this.dataTableBloc.fetchVerifikasi({
      year: this.state.year,
      month: this.state.month,
    });
  }

  confirmResponse = (response) => {
    let forState = {};
    //tambahan rudi
    if (this.state.runType == 4) {
      // this.setState({
      //     showUpload: true,
      //     confirm: false,
      //     // skpgeneratedmsg: '',
      //   });
      switch (response) {
        case "cancel":
          forState = {
            confirm: false,
            showUpload: false,
            // skpgeneratedmsg: '',
          };
          break;
        case "confirm":
          forState = {
            showUpload: true,
            // skpgeneratedmsg: '',
            confirm: false,
          };
          break;
        default:
      } //end case
    } else {
      switch (response) {
        case "cancel":
          forState = {
            confirm: false,
          };
          break;
        case "confirm":
          forState = {
            loading: true,
            confirm: false,
          };

          if (this.state.runType == 1) {
            this.submitData();
          }

          if (this.state.runType == 2) {
            this.handleGenerateUlang();
          }

          if (this.state.runType == 3) {
            this.handleButtonVerifikasi();
          }

          break;
        case "success":
          forState = {
            success: false,
            redirect: true,
            showUpload: false,
          };
          break;
        case "failed":
          forState = {
            failed: false,
          };
          break;
        default:
      } //end case
    }
    this.setState(forState);
  };

  handleButtonExport() {
    this.activeRef.current.handleButtonExport();
  }
  checkdataskp = () => {
    // alert('aaaaa')
    this.dataTableBloc.fetchCheckSkp({
      year: this.state.year,
      month: this.state.month,
    });
  };

  checkDataSKPWithoutModal = () => {
    // alert('aaaaa')
    this.dataTableBloc.fetchCheckSkpWithoutModal({
      year: this.state.year,
      month: this.state.month,
    });
  };

  dateParse = (input) => {
    let res = "";
    if (input !== "" && input != null) {
      res = moment(input).format("DD/MM/YYYY");
    }
    return res;
  };
  checkverifikasi = () => {
    this.dataTableBloc.fetchCheckVerifikasi({
      year: this.state.year,
      month: this.state.month,
    });
  };
  componentDidMount() {
    // this.dataTableBloc.workUnitChannel.subscribe((result) => {
    //   switch (result.status) {
    //     case apiResponse.COMPLETED:
    //       if (result.data.status) {
    //         let response = result.data.response;
    //         this.setState({
    //           workUnitOptions: reformatWorkUnit(response.result),
    //         });
    //       }
    //       break;
    //     case apiResponse.ERROR:
    //       break;
    //     default:
    //       break;
    //   }
    // });

    // this.dataTableBloc.listAtasanChannel.subscribe((result) => {
    //   switch (result.status) {
    //     case apiResponse.COMPLETED:
    //       if (result.data.status) {
    //         let response = result.data.response;
    //         this.setState({
    //           atasanOptions: reformatAtasan(response.result),
    //         });
    //       }
    //       break;
    //     case apiResponse.ERROR:
    //       break;
    //     default:
    //       break;
    //   }
    // });

    // this.createBloc.createChannel.subscribe((result) => {
    //   switch (result.status) {
    //     case apiResponse.COMPLETED:
    //       this.setState({
    //         loading: false,
    //         success: true,
    //       });
    //       this.activeRef.current.setTokenAPI();
    //       break;
    //     case apiResponse.ERROR:
    //       this.setState({
    //         loading: false,
    //         failed: true,
    //       });
    //       break;
    //     default:
    //       break;
    //   }
    // });
    this.createBloc.createChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED: {
          const res = result.data;

          if (res && res.status === true) {
            this.setState({
              loading: false,
              success: true,
              failed: false,
            });
            this.activeRef.current.setTokenAPI();
            this.checkDataSKPWithoutModal();

            if (res.response && res.response.failed_data && res.response.failed_data.length > 0) {
              setTimeout(() => {
                this.setState({
                  showListModal: true,
                  listModalTitle: "Gagal Disimpan (Validasi)",
                  listModalData: res.response.failed_data
                });
              }, 500);
            }
          } else {
            this.setState({
              loading: false,
              failed: true,
              success: false,
              failedTitle: "Gagal",
              failedInfo: res?.message || "Terjadi kesalahan",
            });
          }
          break;
        }

        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
            failedTitle: "Error",
            failedInfo: "Gagal menghubungi server",
          });
          break;

        default:
          break;
      }
    });

    this.dataTableBloc.checkSkpChannel.subscribe((result) => {
      var months = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
      ];
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (parseInt(result.data.response.count) > 0) {
            this.setState({
              confirm: true,
              runType: 4,
              confirmTitle: "Perhatian !",
              confirmInfo:
                "Data SKP tahun " +
                this.state.year +
                " bulan " +
                months[this.state.month - 1] +
                " sudah diupload oleh " +
                result.data.response.detail.employee_full_name +
                " pada " +
                this.dateParse(
                  result.data.response.detail.upload_skp_create_date
                ) +
                ". Apakah anda yakin akan melakukan upload ulang?",

              skpgeneratedmsg:
                "Data SKP tahun " +
                this.state.year +
                " bulan " +
                months[this.state.month - 1] +
                " sudah diupload oleh " +
                result.data.response.detail.employee_full_name +
                " pada " +
                this.dateParse(
                  result.data.response.detail.upload_skp_create_date
                ),
            });
          } else {
            this.setState({
              showUpload: true,
              previewData: null,
              previewSummary: null,
              errorPreview: false
            });
          }
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });

    this.dataTableBloc.checkSkpWithoutModalChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          this.setState({
            loadingCekSKP: true,
          });
          break;
        case apiResponse.COMPLETED:
          if (parseInt(result.data.response.count) > 0) {
            this.setState({
              employee_full_name: result.data.response.detail
                ? result.data.response.detail.employee_full_name
                : null,
              upload_skp_create_date: result.data.response.detail
                ? result.data.response.detail.upload_skp_create_date
                : null,
              loadingCekSKP: false,
            });
          } else {
            this.setState({
              loadingCekSKP: false,
            });
          }
          break;
        case apiResponse.ERROR:
          this.setState({
            loadingCekSKP: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });

    this.dataTableBloc.checkVerifikasiChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          const response = result.data.response;
          // var lockupload = 1;
          // if (
          //   this.state.month == this.state.currentMonth + 1 ||
          //   (response.result == 0 &&
          //     this.state.month == this.state.currentMonth)
          // ) {
          //   lockupload = 0;
          // }

          this.setState({
            skpisverified: response.result,
            // lockupload: lockupload,
          });
          // this.props.setDocument(response?.document);
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.dataTableBloc.previewUploadChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.LOADING:
          this.setState({
            loadingPreview: true,
            errorPreview: false
          });
          break;
        case apiResponse.COMPLETED:
          if (result.data.status) {
             this.setState({
               loadingPreview: false,
               previewData: result.data.response.preview_data,
               previewSummary: result.data.response.summary,
             });
          } else {
             this.setState({
               loadingPreview: false,
               errorPreview: result.data.message
             });
          }
          break;
        case apiResponse.ERROR:
          this.setState({
            loadingPreview: false,
            errorPreview: "Gagal memproses file Excel."
          });
          break;
        default:
          break;
      }
    });
    // this.dataTableBloc.fetchWorkUnit({ status: 1 });
    // if (this.is_eselon == 1 || this.state.roleId == 1) {
    //   this.dataTableBloc.fetchAtasan({
    //     roleId: this.state.roleId,
    //     is_echelon: this.is_eselon,
    //   });
    // }
    this.handleperiodePenilaian(this.state.month, this.state.year);
    this.checkDataSKPWithoutModal();
  }

  componentWillUnmount() {
    this.dataTableBloc.workUnitChannel?.unsubscribe();
    this.dataTableBloc.listAtasanChannel?.unsubscribe();
    this.createBloc.createChannel?.unsubscribe();
    this.dataTableBloc.checkSkpChannel?.unsubscribe();
    this.dataTableBloc.checkSkpWithoutModalChannel?.unsubscribe();
    this.dataTableBloc.previewUploadChannel?.unsubscribe();
  }

  render() {
    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <CardTitle>Daftar Laporan Penilaian SKP</CardTitle>
                  <CardSubtitle className="mb-3">
                    Kelola Daftar Laporan Penilaian SKP
                  </CardSubtitle>
                  <hr />

                  {/* Start of : Menu Filter Untuk Eselon 1 & 2 dan Administrator  */}
                  {this.is_eselon == 1 || this.state.roleId == 1 ? (
                    <>
                      <Row className="mb-3">
                        <label
                          htmlFor="no_skx"
                          className="col-md-2 col-form-label"
                        >
                          Periode SKP <span className="text-danger">*</span>
                        </label>
                        <Col md="2">
                          <CustomSelect
                            name="period_month"
                            errorMessage="Pilih Bulan"
                            options={this.state.monthOptions}
                            placeholder="Pilih Bulan"
                            defaultValue={this.state.month}
                            onChange={(v) => {
                              this.setState({ month: v.value });
                              this.handleperiodePenilaian(
                                v.value,
                                this.state.year
                              );
                            }}
                            isAvForm={false}
                          />
                        </Col>
                        <Col md="2">
                          <CustomSelect
                            name="period_year"
                            errorMessage="Pilih Tahun"
                            options={this.state.yearOptions}
                            placeholder="Pilih Tahun"
                            defaultValue={this.state.year}
                            onChange={(v) => {
                              this.setState({ year: v.value });
                              this.handleperiodePenilaian(
                                this.state.month,
                                v.value
                              );
                            }}
                            isAvForm={false}
                          />
                        </Col>
                      </Row>
                      <Row className="mb-3" style={{ display: "none" }}>
                        <label
                          htmlFor="no_skx"
                          className="col-md-2 col-form-label"
                        >
                          Periode Penilaian
                        </label>
                        <Col md="2">
                          <CustomSelect
                            name="period_month_penilaian"
                            errorMessage="Pilih Bulan"
                            options={this.state.monthOptions}
                            placeholder="Pilih Bulan"
                            defaultValue={this.state.bulanpenilaian}
                            // onChange={(v) => this.setState({ month: v.value })}
                            isAvForm={false}
                            isDisabled={true}
                          />
                        </Col>
                        <Col md="2">
                          <CustomSelect
                            name="period_year_penilaian"
                            errorMessage="Pilih Tahun"
                            options={this.state.yearOptions}
                            placeholder="Pilih Tahun"
                            defaultValue={this.state.tahunpenilaian}
                            // onChange={(v) => this.setState({ year: v.value })}
                            isAvForm={false}
                            isDisabled={true}
                          />
                        </Col>
                      </Row>

                      {/* <Row className="mb-3">
                        <label
                          htmlFor="no_skx"
                          className="col-md-2 col-form-label"
                        >
                          Tahun <span className="text-danger">*</span>
                        </label>
                        <Col md="2">
                          <CustomSelect
                            name="period_year"
                            errorMessage="Pilih Tahun"
                            options={this.state.yearOptions}
                            placeholder="Pilih Tahun"
                            defaultValue={this.state.year}
                            onChange={(v) => this.setState({ year: v.value })}
                            isAvForm={false}
                          />
                        </Col>
                      </Row> */}
                      <br />
                      {/* <Row className="mb-3">
                        <label
                          htmlFor="work_unit_hirarki"
                          className="col-md-2 col-form-label"
                        >
                          Atasan Langsung <span className="text-danger">*</span>
                        </label>
                        <Col md="2">
                          <CustomSelect
                            name="work_unit_hirarki"
                            errorMessage="Pilih Atasan"
                            options={this.state.atasanOptions}
                            placeholder="Pilih Atasan"
                            defaultValue={
                              this.state.roleId == 2 && this.is_eselon == 1
                                ? this.state.atasanSelected
                                : ""
                            }
                            onChange={(v) =>
                              this.setState({ atasanSelected: v.value })
                            }
                            isAvForm={false}
                          />
                        </Col>
                      </Row>

                      <Row className="mb-3">
                        <label
                          htmlFor="work_unit"
                          className="col-md-2 col-form-label"
                        >
                          Unit Kerja <span className="text-danger">*</span>
                        </label>
                        <Col md="2">
                          <CustomSelect
                            name="work_unit"
                            errorMessage="Pilih Unit Kerja"
                            options={this.state.workUnitOptions}
                            placeholder="Pilih Unit Kerja"
                            // defaultValue={this.state.month}
                            onChange={(v) =>
                              this.setState({ workUnitSelected: v.value })
                            }
                            isAvForm={false}
                          />
                        </Col>
                      </Row> */}
                    </>
                  ) : (
                    ""
                  )}
                  {/* End  of : Menu Filter Untuk Eselon 1 & 2 dan Administrator  */}

                  {/* Start of : Menu Filter Pegawai yang bukan eselon 1 & 2  */}
                  {this.is_eselon == 0 && this.state.roleId == 2 ? (
                    <>
                      <Row className="mb-3">
                        <label
                          htmlFor="no_skx"
                          className="col-md-2 col-form-label"
                        >
                          Periode Pembayaran{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <Col md="2">
                          <CustomSelect
                            name="period_month"
                            errorMessage="Pilih Bulan"
                            options={this.state.monthOptions}
                            placeholder="Pilih Bulan"
                            defaultValue={this.state.month}
                            onChange={(v) => {
                              this.setState({ month: v.value });
                              this.handleperiodePenilaian(
                                v.value,
                                this.state.year
                              );
                            }}
                            isAvForm={false}
                          />
                        </Col>
                        <Col md="2">
                          <CustomSelect
                            name="period_year"
                            errorMessage="Pilih Tahun"
                            options={this.state.yearOptions}
                            placeholder="Pilih Tahun"
                            defaultValue={this.state.year}
                            onChange={(v) => {
                              this.setState({ year: v.value });
                              this.handleperiodePenilaian(
                                this.state.month,
                                v.value
                              );
                            }}
                            isAvForm={false}
                          />
                        </Col>
                      </Row>
                      <Row className="mb-3" style={{ display: "none" }}>
                        <label
                          htmlFor="no_skx"
                          className="col-md-2 col-form-label"
                        >
                          Periode Penilaian
                        </label>
                        <Col md="2">
                          <CustomSelect
                            name="period_month_penilaian"
                            errorMessage="Pilih Bulan"
                            options={this.state.monthOptions}
                            placeholder="Pilih Bulan"
                            defaultValue={this.state.bulanpenilaian}
                            // onChange={(v) => this.setState({ month: v.value })}
                            isAvForm={false}
                            isDisabled={true}
                          />
                        </Col>
                        <Col md="2">
                          <CustomSelect
                            name="period_year_penilaian"
                            errorMessage="Pilih Tahun"
                            options={this.state.yearOptions}
                            placeholder="Pilih Tahun"
                            defaultValue={this.state.tahunpenilaian}
                            // onChange={(v) => this.setState({ year: v.value })}
                            isAvForm={false}
                            isDisabled={true}
                          />
                        </Col>
                      </Row>
                      {/* <Row className="mb-3">
                        <label
                          htmlFor="no_skx"
                          className="col-md-2 col-form-label"
                        >
                          Bulan <span className="text-danger">*</span>
                        </label>
                        <Col md="2">
                          <CustomSelect
                            name="period_month"
                            errorMessage="Pilih Bulan"
                            options={this.state.monthOptions}
                            placeholder="Pilih Bulan"
                            defaultValue={this.state.month}
                            onChange={(v) => this.setState({ month: v.value })}
                            isAvForm={false}
                          />
                        </Col>
                      </Row>

                      <Row className="mb-3">
                        <label
                          htmlFor="no_skx"
                          className="col-md-2 col-form-label"
                        >
                          Tahun <span className="text-danger">*</span>
                        </label>
                        <Col md="2">
                          <CustomSelect
                            name="period_year"
                            errorMessage="Pilih Tahun"
                            options={this.state.yearOptions}
                            placeholder="Pilih Tahun"
                            defaultValue={this.state.year}
                            onChange={(v) => this.setState({ year: v.value })}
                            isAvForm={false}
                          />
                        </Col>
                      </Row> */}

                      <Row className="mb-3">
                        <label
                          htmlFor="work_unit_hirarki"
                          className="col-md-2 col-form-label"
                        >
                          Nama
                        </label>
                        <Col md="2">
                          <label
                            htmlFor="work_unit_hirarki"
                            className="col-form-label"
                          >
                            {this.userdata.employee_full_name}
                          </label>
                        </Col>
                      </Row>

                      <Row className="mb-3">
                        <label
                          htmlFor="work_unit_hirarki"
                          className="col-md-2 col-form-label"
                        >
                          NIP
                        </label>
                        <Col md="2">
                          <label
                            htmlFor="work_unit_hirarki"
                            className="col-form-label"
                          >
                            {this.userdata.employee_nip}
                          </label>
                        </Col>
                      </Row>
                      <Row className="mb-3">
                        <label
                          htmlFor="work_unit_hirarki"
                          className="col-md-2 col-form-label"
                        >
                          Jabatan
                        </label>
                        <Col md="6">
                          <label
                            htmlFor="work_unit_hirarki"
                            className="col-form-label"
                          >
                            {this.userdata.employee_current_position_name}
                          </label>
                        </Col>
                      </Row>
                      <Row className="mb-3">
                        <label
                          htmlFor="work_unit_hirarki"
                          className="col-md-2 col-form-label"
                        >
                          Unit Kerja
                        </label>
                        <Col md="6">
                          <label
                            htmlFor="work_unit_hirarki"
                            className="col-form-label"
                          >
                            {this.userdata.employee_current_work_unit_name}
                          </label>
                        </Col>
                      </Row>
                    </>
                  ) : (
                    ""
                  )}
                  {/* End  of : Menu Filter Untuk Eselon 1 & 2 dan Administrator  */}

                  <Row className="mb-3">
                    <Col md="2"></Col>
                    <Col md="10">
                      <Button
                        color="primary"
                        type="button"
                        onClick={() => {
                          this.activeRef.current.setTokenAPI();
                          this.checkverifikasi();
                        }}
                      >
                        <i className="uil-search-alt"></i> Cari
                      </Button>{" "}
                      {/* Start of : Tombol Upload E-Kinerja, Generate, Verifikasi, Export untuk Administrator */}
                      {this.state.roleId == 1 ? (
                        <>
                          <Button
                            color="success"
                            type="button"
                            onClick={() => {
                              // Only check SKP once to show upload modal or overwrite confirmation.
                              // Do not refresh list here to avoid heavy load.
                              this.checkdataskp();
                            }}
                            // disabled={
                            //   !!!this.state.month && !!!this.state.month && this.state.lockupload == 0
                            // }
                            // dikomen keperluan test dev
                            disabled={this.state.lockupload == 1 ? true : false}
                          >
                            <i className="uil-upload"></i> Upload Data E-Kinerja
                          </Button>{" "}
                          <Button
                            color="warning"
                            type="button"
                            onClick={() => {
                              this.handleButtonExport();
                            }}
                          >
                            <i className="uil-file-download"></i> Export Xls
                          </Button>
                        </>
                      ) : (
                        ""
                      )}
                      {/* End of : Tombol Upload E-Kinerja, Generate, Verifikasi, Export untuk Administrator */}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col md="8">
                      <br></br>

                      {this.state.loadingCekSKP === true ? (
                        <Col md="10">
                          <Shimmer>
                            <div
                              style={{
                                width: "100%",
                                height: 30,
                                marginBottom: "10px",
                              }}
                            ></div>
                          </Shimmer>
                        </Col>
                      ) : this.state.document ? (
                        <b>
                          Status Upload Excel Data SKP Periode{" "}
                          {this.getMonthName(this.state.month) +
                            " " +
                            this.state.year}{" "}
                          :{" "}
                          <Badge className="badge bg-success font-size-14">
                            {" "}
                            Telah dilakukan Upload oleh{" "}
                            {this.state.employee_full_name} pada tanggal{" "}
                            {this.formatDateWithTime(
                              this.state.upload_skp_create_date
                            )}
                          </Badge>{" "}
                          <a
                            color="primary"
                            type="button"
                            href={this.state.document?.documents_path}
                          >
                            <i className="uil-file"></i>
                          </a>
                        </b>
                      ) : (
                        <b>
                          Status Upload Excel Data SKP Periode{" "}
                          {this.getMonthName(this.state.month) +
                            " " +
                            this.state.year}{" "}
                          :{" "}
                          <Badge className="badge bg-danger font-size-14">
                            {" "}
                            Belum Dilakukan{" "}
                          </Badge>
                        </b>
                      )}
                    </Col>
                  </Row>
                  
                  <Row className="mb-3">
                    <Col md={12}>
                      <div className="float-end">
                        {accessRole("create") ? (
                          <Link to="?create">
                              <Button color="primary">
                                Tambah Data Penilaian SKP
                              </Button>
                            </Link>
                        ) : null}
                      </div>
                    </Col>
                  </Row>

                  <hr />
                  <TableActiveComponent
                    ref={this.activeRef}
                    setDocument={(doc) => this.setState({ document: doc })}
                    additionalFilter={{
                      year: this.state.year,
                      month: this.state.month,
                      workunit: this.state.workUnitSelected,
                      employee_uuid: this.state.atasanSelected,
                    }}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
          <ConfirmAlert
            confirmTitle="Konfirmasi!"
            confirmInfo={this.state.confirmInfo}
            loadingTitle="Mengirim data..."
            loadingInfo="Tunggu beberapa saat"
            successTitle="Berhasil!"
            successInfo="Data berhasil disimpan"
            failedTitle={this.state.failedTitle}
            failedInfo={this.state.failedInfo}
            alertInfo="aaaaaaaaaaaaaa"
            showConfirm={this.state.confirm}
            showLoading={this.state.loading}
            showSuccess={this.state.success}
            showFailed={this.state.failed}
            response={this.confirmResponse}
          />
          <Modal size={"xl"} isOpen={this.state.showUpload}>
            <div className="modal-header">
              <h5 className="modal-title mt-0" id="myLargeModalLabel">
                Upload Data E-Kinerja
              </h5>
              <button
                onClick={() => {
                  this.setState({
                    showUpload: false,
                    skpgeneratedmsg: "",
                    previewData: null,
                    previewSummary: null,
                    previewSearch: "",
                  });
                }}
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <AvForm
              className="needs-validation"
              onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
            >
              <div className="modal-body">
                <a
                  href={
                    process.env.REACT_APP_SERVICE_CORE_URL +
                    "/templates/Template_SKP.xlsx"
                  }
                  target="_blank"
                  rel="noreferrer"
                >
                  Unduh template...
                </a>
                <br />
                <br />
                <FileInput
                  name="special_allowance_summary_doc"
                  validate={{ required: { value: false } }}
                  maxFiles={1}
                />
                <br />
                {this.state.skpgeneratedmsg != "" ? (
                  <div class="alert alert-danger fade show" role="alert">
                    {this.state.skpgeneratedmsg}
                  </div>
                ) : (
                  ""
                )}

                {this.state.loadingPreview && (
                  <div className="text-center mt-3">
                    <div className="spinner-border text-primary" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                    <p>Memproses preview data...</p>
                  </div>
                )}
                {this.state.errorPreview && (
                  <div className="alert alert-danger mt-3">
                    {this.state.errorPreview}
                  </div>
                )}
                {this.state.previewSummary && (
                  <div className="mt-4">
                    <h5 className="mb-3">Informasi Data E-Kinerja</h5>
                    <Row className="justify-content-center">
                      <Col md="8">
                         <div className="card shadow-sm mb-3">
                            <div className="card-body py-3">
                               <Row>
                                 <Col sm="3" className="text-center border-end">
                                   <div className="avatar-xs mx-auto mb-2">
                                       <span className="avatar-title rounded-circle bg-primary bg-soft text-primary font-size-18">
                                           <i className="mdi mdi-account-group"></i>
                                       </span>
                                   </div>
                                   <h5 className="font-size-14 mb-0">Total Data<br/><span className="text-primary mt-1 d-inline-block">{this.state.previewSummary.total_data} Orang</span></h5>
                                 </Col>
                                 <Col sm="3" className="text-center border-end" style={{ cursor: "pointer" }} onClick={() => this.setState({ showListModal: true, listModalTitle: "Update Data", listModalData: this.state.previewSummary.update_names })}>
                                   <div className="avatar-xs mx-auto mb-2">
                                       <span className="avatar-title rounded-circle bg-warning bg-soft text-warning font-size-18">
                                           <i className="mdi mdi-account-convert"></i>
                                       </span>
                                   </div>
                                   <h5 className="font-size-14 mb-0 text-decoration-underline text-warning">Update Data<br/><span className="mt-1 d-inline-block">{this.state.previewSummary.update_data} Orang</span></h5>
                                 </Col>
                                 <Col sm="3" className="text-center border-end" style={{ cursor: "pointer" }} onClick={() => this.setState({ showListModal: true, listModalTitle: "Data Baru", listModalData: this.state.previewSummary.new_names })}>
                                   <div className="avatar-xs mx-auto mb-2">
                                       <span className="avatar-title rounded-circle bg-success bg-soft text-success font-size-18">
                                           <i className="mdi mdi-account-plus"></i>
                                       </span>
                                   </div>
                                   <h5 className="font-size-14 mb-0 text-decoration-underline text-success">Data Baru<br/><span className="mt-1 d-inline-block">{this.state.previewSummary.new_data} Orang</span></h5>
                                 </Col>
                                 <Col sm="3" className="text-center" style={{ cursor: "pointer" }} onClick={() => this.setState({ showListModal: true, listModalTitle: "Gagal Proses", listModalData: this.state.previewSummary.failed_names })}>
                                   <div className="avatar-xs mx-auto mb-2">
                                       <span className="avatar-title rounded-circle bg-danger bg-soft text-danger font-size-18">
                                           <i className="mdi mdi-account-remove"></i>
                                       </span>
                                   </div>
                                   <h5 className="font-size-14 mb-0 text-decoration-underline text-danger">Gagal Proses<br/><span className="mt-1 d-inline-block">{this.state.previewSummary.failed_data} Orang</span></h5>
                                 </Col>
                               </Row>
                            </div>
                         </div>
                      </Col>
                    </Row>
                  </div>
                )}
                {this.state.previewData && (
                  <div className="mt-2">
                     <div className="d-flex justify-content-end mb-2">
                        <input
                           type="text"
                           className="form-control form-control-sm w-25"
                           placeholder="Cari Nama, NIP, Plt/Plh..."
                           value={this.state.previewSearch}
                           onChange={(e) => this.setState({ previewSearch: e.target.value })}
                        />
                     </div>
                     <div className="table-responsive" style={{ maxHeight: "400px", overflowY: "auto" }}>
                        <table className="table table-bordered table-striped table-sm mb-0">
                           <thead className="table-light sticky-top">
                              <tr>
                                 <th>Informasi Pegawai</th>
                                 <th>Jabatan</th>
                                 <th>Plt/Plh</th>
                                 <th>Hasil Kerja</th>
                                 <th>Perilaku</th>
                                 <th>Hasil Akhir</th>
                                 <th>Status</th>
                              </tr>
                           </thead>
                           <tbody>
                              {this.state.previewData.filter(row => {
                                 if (!this.state.previewSearch) return true;
                                 const q = this.state.previewSearch.toLowerCase();
                                 return (row.nama || '').toLowerCase().includes(q) || 
                                        (row.nip || '').toLowerCase().includes(q) || 
                                        (row.jenis_jabatan || '').toLowerCase().includes(q);
                              }).map((row, idx) => (
                                 <tr key={idx}>
                                    <td>
                                       <div>{row.nip}</div>
                                       <div className="fw-bold">{row.nama}</div>
                                    </td>
                                 <td>{row.jabatan}</td>
                                 <td>{row.jenis_jabatan}</td>
                                 <td>{row.hasil_kerja}</td>
                                 <td>{row.perilaku_kerja}</td>
                                 <td>{row.hasil_akhir}</td>
                                 <td>
                                    {row.is_update ? 
                                       <span className="badge bg-warning">Update</span> : 
                                       <span className="badge bg-success">Baru</span>
                                    }
                                 </td>
                              </tr>
                           ))}
                        </tbody>
                     </table>
                  </div>
                </div>
                )}

              </div>
              <div className="modal-footer">
                {this.state.document && (
                  <a
                    href={this.state.document?.documents_path}
                    target="_blank"
                    className="me-auto"
                  >
                    Download Document Sebelum nya
                  </a>
                )}
                <Button
                  color="primary"
                  type="submit"
                >
                  Preview Data
                </Button>{" "}
                {this.state.previewData && (
                  <Button
                    color="success"
                    type="button"
                    onClick={() => {
                      this.setState({
                        confirm: true,
                        runType: 1,
                        confirmInfo:
                          "Apakah anda yakin akan melakukan Upload Data E-Kinerja? Data akan diperbarui sesuai preview.",
                      });
                    }}
                  >
                    Konfirmasi Simpan
                  </Button>
                )}
                <Button
                  color="danger"
                  onClick={() => {
                    this.setState({
                      showUpload: false,
                      skpgeneratedmsg: "",
                    });
                  }}
                >
                  Cancel
                </Button>
              </div>
            </AvForm>
          </Modal>
          <Modal isOpen={this.state.showListModal} toggle={() => this.setState({ showListModal: false })}>
            <div className="modal-header">
              <h5 className="modal-title mt-0">{this.state.listModalTitle}</h5>
              <button
                type="button"
                className="close"
                onClick={() => this.setState({ showListModal: false })}
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body" style={{ maxHeight: "400px", overflowY: "auto" }}>
              {this.state.listModalData && this.state.listModalData.length > 0 ? (
                <ul className="list-group">
                  {this.state.listModalData.map((person, idx) => (
                    <li className="list-group-item d-flex justify-content-between align-items-start" key={idx}>
                      <div>
                        <h6 className="my-0">{person.nama}</h6>
                        <small className="text-muted">{person.nip}</small>
                        {person.reason && (
                           <div className="text-danger mt-1" style={{ fontSize: "12px" }}>
                              <i className="mdi mdi-alert-circle-outline me-1"></i>
                              {person.reason}
                           </div>
                        )}
                      </div>
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="text-center text-muted my-3">Tidak ada data.</p>
              )}
            </div>
            <div className="modal-footer">
              <Button color="secondary" onClick={() => this.setState({ showListModal: false })}>Tutup</Button>
            </div>
          </Modal>
        </Container>
      </Fragment>
    );
  }
}

export default IndexView;
